import { render, staticRenderFns } from "./ColleagueSelect.vue?vue&type=template&id=c172c066&scoped=true"
import script from "./ColleagueSelect.vue?vue&type=script&lang=js"
export * from "./ColleagueSelect.vue?vue&type=script&lang=js"
import style0 from "./ColleagueSelect.vue?vue&type=style&index=0&id=c172c066&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c172c066",
  null
  
)

export default component.exports